import {
  createTheme,
  ThemeProvider,
  Menu,
  MenuItem,
  Stack,
  Box,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  TextField,
  Autocomplete,
  CircularProgress,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  FormControl,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CoPresentOutlinedIcon from "@mui/icons-material/CoPresentOutlined";
import MUIDataTable from "mui-datatables";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useLocalStorageContext } from "../../../Context/LocalProvider";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { Select } from "@mui/material";

import config from "../../../Data/AuthUser";
import { clientApis, clientDriversApis, DriverApis } from "../../../Data/axios";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../Components/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReactQuill from "react-quill";
import { getUserInfo } from "../../../Data/UserData";
import DriverClientsHeader from "./DriverClientsHeader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DriverClients() {
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [salary, setSalary] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [driverData, setDriverData] = useState([]);
  const [name, setName] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [driverId, setDriverId] = useState("");
  const [driverIdValue, setDriverIdValue] = useState("");
  const [optionsNew, setOptionsNew] = useState([]);
  const [loadingNew, setLoadingNew] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState([]);
  const [relieveId, setRelieveId] = useState([]);
  const { data: userData } = useLocalStorageContext();
  const [search, setSearch] = useState("");
  const [finalValue, setFinalValue] = useState(1);
  const navigate = useNavigate();
  const [rowCountValue, setRowCountValue] = useState(0);
  const [descriptionReason, setDescriptionReason] = React.useState("");
  const [descriptionSuspend, setDescriptionSuspend] = React.useState("");
  const [detailValue, setDetailValue] = useState("");
  const [pageValue, setPageValue] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [selection, setSelection] = useState(null);
  const [selectionStatus, setSelectionStatus] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [followup, setFollowup] = React.useState(false);
  const location = useLocation();
  const [remarkType, setRemarkType] = useState("");
  const openMenuIdNew = location.state;
  useEffect(() => {
    getDataPass();
  }, [openMenuIdNew]);
  const handleChange = (event) => {
    setRemarkType(event.target.value);
  };
  const getDataPass = async () => {
    const rowData = await clientApis.clientViewMoreId(openMenuIdNew);
    setDetailValue(rowData);
  };
  const [openDate, setOpenDate] = React.useState(false);
  const [openSuspend, setOpenSuspend] = React.useState(false);
  const { client, app_user } = detailValue || {};
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };
  const { id: userId } = useParams();
  const { user_id } = client || {};
  const { username } = app_user || {};
  const [date, setDate] = useState(null);
  const [dateRelieve, setDateRelieve] = useState(null);
  const handleDriverChange = (value) => {
    if (value) {
      setSelectedDriver(value.user_id);
    } else {
      setSelectedDriver(null);
    }
  };
  const handleCloseRelieve = () => {
    setOpenDate(false);
    setDateRelieve(null);
  };
  const handleCloseSuspend = () => {
    setOpenSuspend(false);
  };
  useEffect(() => {
    if (driverId && driverId.length > 11) {
      // Trigger API call when driver_id has sufficient length
      setLoadingNew(true);
      fetchOptionsByDriverId(driverId)
        .then((response) => {
          setOptionsNew([response]); // Ensure response is an array before setting options
          setLoadingNew(false);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          setOptionsNew([]);
          setLoadingNew(false);
        });
    } else {
      setOptionsNew([]); // Clear options if input is too short
    }
  }, [driverId]);

  const fetchOptionsByDriverId = async (driverId) => {
    const data = await clientDriversApis.getDriver(driverId);

    return data.user;
  };

  const userDataNew = localStorage.getItem("user-info");
  let creator;
  if (userDataNew) {
    // Parse the JSON string into an object
    const parsedData = JSON.parse(userDataNew);

    // Access the name property from the parsed object
    creator = parsedData.value.empid;
  } else {
    console.error("No user data found in localStorage.");
  }
  useEffect(() => {
    filteredDriverValue();
  }, [search, setSearch]);

  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const filteredDriverValue = () => {
    const searchLower = search.toLowerCase();
    const filtered = driverData.filter((driver) => {
      return (
        (driver.username &&
          driver.username.toLowerCase().includes(searchLower)) ||
        (driver.phone && driver.phone.includes(search)) ||
        (driver.user_id && driver.user_id.toString().includes(search))
      );
    });
    setFilteredDrivers(filtered); // Update state with the filtered data
  };
  const item = {
    client_id: user_id,
    salary: salary,
    // allowance: allowance,
    join_date: date,
  };

  async function SaveData() {
    console.log(item, "all itaem of driver got");

    // Create a new FormData object
    const formData = new FormData();

    // Append each item to the FormData object
    for (const key in item) {
      if (item[key] !== undefined && item[key] !== null) {
        formData.append(key, item[key]);
      }
    }
    try {
      const result = await clientDriversApis.SavebyId(selectedDriver, formData);
      if (result === 1601) {
        showAlert("Driver is already allotted", "warning");
      } else {
        showAlert("Added successfully", "success");
        getData();
        setOpen(false);
        setName("");
        setSearch("");
      }
    } catch {
      showAlert("Failed to add. Please try again.", "error");
    }
  }

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeSelected = async (event, Id, driverIdNew) => {
    const selectedValue = event.target.value;
    if (selectedValue === 3) {
      setDriverIdValue(driverIdNew);
      setRelieveId(Id);
      setOpenDate(true);
      setFinalValue(selectedValue);
    } else if (selectedValue === 0) {
      setDriverIdValue(driverIdNew);
      setRelieveId(Id);
      setOpenSuspend(true);
      setFinalValue(selectedValue);
    } else {
      const itemStatus = { status: selectedValue };
      const formData = new FormData();

      for (const key in itemStatus) {
        if (itemStatus[key] !== undefined && itemStatus[key] !== null) {
          formData.append(key, itemStatus[key]);
        }
      }
      try {
        await clientDriversApis.changeStatus(Id, formData);

        showAlert("Status updated successfully", "success");
        getData();
      } catch (error) {
        showAlert("Failed to Change Status. Please try again.", "error");
      }
    }
  };

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleDateChange = (newDate) => {
    setDate(newDate); // Update the date state
  };
  const handleDateChangeRelieve = async (newDate) => {
    setDateRelieve(newDate);
    // After setting dateRelieve, call handleRelieveStatus
  };
  const handleViewMore = async () => {
    const rowData = await clientDriversApis.viewMoreDriver(openMenuId);

    navigate(`/clients/driver/${openMenuId}`, {
      state: rowData,
      clientId: user_id,
    });
  };

  const handleViewAttendence = async () => {
    const formData = new FormData();
    formData.append("client_id", user_id);

    const rowData = await clientDriversApis.viewMoreAttendance(
      openMenuId,
      formData
    );

    navigate(`/clients/driver/${openMenuId}/attendance`, { state: rowData });
  };

  const [leadFiles, setLeadFiles] = useState([]);
  useEffect(() => {
    getData();
  }, [
    userId,
    pageValue,
    rowsPerPage,
    selection?.props?.value,
    searchValue,
    selectionStatus,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    getDrivers();
  }, []);
  async function getDrivers() {
    const result = await DriverApis.getAll();

    if (result.success) {
      // setLeadFiles(result?.data?.data);
      setDriverData(result?.data?.appusers);
    } else {
      showAlert(`${result.message}`, "error");
      console.log(`Error ${result.status}: ${result.message}`);
    }
  }
  async function getData() {
    const result = await clientDriversApis.getAll(
      userId,
      pageValue,
      rowsPerPage,
      selection?.props?.value,
      searchValue,
      selectionStatus,
      startDate,
      endDate
    );

    if (result.success) {
      setLeadFiles(result?.data?.data);
      setTotalPages(result?.data.total_pages);
      setRowCountValue(result?.data.total_records);
    } else {
      showAlert(`${result.message}`, "error");
      console.log(`Error ${result.status}: ${result.message}`);
    }
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const dateValue = dateRelieve ? new Date(dateRelieve) : null;
  let formattedDate = " ";

  if (dateValue && !isNaN(dateValue)) {
    const day = String(dateValue.getDate()).padStart(2, "0");
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const year = dateValue.getFullYear();
    formattedDate = `${day}-${month}-${year}`;
  }

  const itemRelieve = {
    status: finalValue,
    releave_date: formattedDate,
    note_to: user_id,
    note: descriptionReason,
    note_type: remarkType,
  };

  async function handleRelieve() {
    const formData = new FormData();
    for (const key in itemRelieve) {
      if (itemRelieve[key] !== undefined && itemRelieve[key] !== null) {
        formData.append(key, itemRelieve[key]);
      }
    }
    try {
      await clientDriversApis.changeStatus(relieveId, formData);
      showAlert("Status updated successfully", "success");
      getData();
      setOpenDate(false);
      setDescriptionReason("");
      setRemarkType("");
      setDateRelieve(null);
    } catch (error) {
      showAlert("Failed to Add Relieve. Please try again.", "error");
    }
  }
  const itemSuspend = {
    status: finalValue,
    note: descriptionSuspend,
  };
  async function handleSuspend() {
    const formData = new FormData();
    for (const key in itemSuspend) {
      if (itemSuspend[key] !== undefined && itemSuspend[key] !== null) {
        formData.append(key, itemSuspend[key]);
      }
    }
    try {
      await clientDriversApis.changeStatus(relieveId, formData);
      showAlert("Status updated successfully", "success");
      getData();
      setOpenSuspend(false);
      setDescriptionSuspend("");
    } catch (error) {
      showAlert("Failed to Add Suspend. Please try again.", "error");
    }
  }
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "app_user",
      label: "Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Name
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const imageUrl = `${config.apiImageUrl}${value.image}`;
          
          const handleNameClick = () => {
            navigate(`/Users/Drivers/${value.user_id}`, {
              state: {
                driverId: value.user_id,
              },
            });
          };
          
          return (
            <td
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={handleNameClick}
              >
                <img
                  src={imageUrl}
                  alt="requester"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: "10px",
                  }}
                />
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {(value.username || "Unknown").charAt(0).toUpperCase() +
                      (value.username || "Unknown").slice(1)}
                  </div>
                  <div>{value.user_id || "Unknown"}</div>
                </div>
              </div>
            </td>
          );
        },
      },
    },
    {
  name: "corp_driver",
  label: "Start Date",
  options: {
    customHeadRender: ({ index }) => {
      return (
        <th
          key={index}
          style={{
            textAlign: "center",
            borderBottom: "1px solid #ddd",
          }}
        >
          Start Date
        </th>
      );
    },
    customBodyRender: (value, tableMeta, updateValue) => {
      const StartDateCell = () => {
        const [open, setOpen] = React.useState(false);
        const [selectedDate, setSelectedDate] = React.useState(
          value?.join_date
            ? new Date(value.join_date).toISOString().slice(0, 10)
            : ""
        );

        let formattedDate = "";
        if (value?.join_date) {
          const d = new Date(value.join_date);
          const day = String(d.getDate()).padStart(2, "0");
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const year = d.getFullYear();
          formattedDate = `${day}-${month}-${year}`;
        }

        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

       const handleSave = async () => {
          try {
            const [year, month, day] = selectedDate.split("-").map(Number);
            const dt = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
            const formattedRFC1123 = dt.toUTCString(); 
            await clientDriversApis.DriverJoiningDate(
              value.id,
              "edit_driver",
              { join_date: formattedRFC1123 }
            );
             updateValue({ ...value, join_date: formattedRFC1123 });

            setOpen(false);
          } catch (err) {
            console.error("Failed to update join date:", err);
          }
        };
        return (
          <>
            {/* Clickable date */}
            <span
              style={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
              }}
              onClick={handleOpen}
            >
              {formattedDate || "Select Date"}
            </span>

            {/* Dialog */}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Update Start Date</DialogTitle>
              <DialogContent>
                <TextField
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  fullWidth
                  margin="dense"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSave}>
                  Update Data
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );
      };

      return <StartDateCell />;
    },
  },
},
    {
      name: "app_user",
      label: "Phone No.",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Phone No.
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={value}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {value.phone || " "}
              </div>
            </td>
          );
        },
      },
    },
    {
      name: "corp_driver",
      label: "Salary",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Salary
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={value}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {value.salary || " "}
              </div>
            </td>
          );
        },
      },
    },
    {
      name: "corp_driver",
      label: "Relieve",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Relieve
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={value.releave_date}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {value?.releave_date}
              </div>
            </td>
          );
        },
      },
    },
    {
      name: "corp_driver",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={value.id}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Select
                  value={value.status}
                  onChange={(event) =>
                    handleChangeSelected(event, value.id, value.driver_id)
                  }
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected === "1") {
                      return (
                        <MenuItem
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          Active
                        </MenuItem>
                      ); // Placeholder text
                    }
                    if (selected === "0") {
                      return (
                        <MenuItem
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          Suspended
                        </MenuItem>
                      ); // Placeholder text
                    }
                    if (selected === "2") {
                      return (
                        <MenuItem
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          Leave
                        </MenuItem>
                      ); // Placeholder text
                    }
                    if (selected === "3") {
                      return (
                        <MenuItem
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          Relieve
                        </MenuItem>
                      ); // Placeholder text
                    }
                    return selected; // Show selected value
                  }}
                  sx={{
                    width: "110px",

                    border: "none",
                    color: "#000 ",
                    bgcolor: "#fff",
                    "& .MuiSelect-select": {
                      padding: 0,
                    },
                  }}
                >
                  <MenuItem
                    value={1}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    Active
                  </MenuItem>
                  <MenuItem
                    value={0}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    Suspended
                  </MenuItem>
                  <MenuItem
                    value={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    Leave
                  </MenuItem>
                  <MenuItem
                    value={3}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    Relieve
                  </MenuItem>
                </Select>
              </div>
            </td>
          );
        },
      },
    },

    {
      name: "corp_driver",
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "20px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <td
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value.driver_id)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore()}
                      className="MenuItemValue"
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEyeOutlinedIcon /> &nbsp; View More
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewAttendence()}
                      className="MenuItemValue"
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <CoPresentOutlinedIcon />
                      &nbsp; Attendence
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </td>
        ),
      },
    },
  ];

  const rowsPerPageOptions = [5, 10, 25, 100];
  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: totalPages, // Adding total pages
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <DriverClientsHeader
        startDate={startDate}
        selection={selection}
        setSelection={setSelection}
        selectionStatus={selectionStatus}
        setSelectionStatus={setSelectionStatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <Dialog
        open={openDate}
        onClose={handleCloseRelieve}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            marginTop: "30px",
            top: 0,
            position: "absolute",
            height: "450px",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            bgcolor: "#1d82F5",
            color: "#fff",
            textAlign: "center",
            width: "100%",
          }}
        >
          {"Do, you want to Relieve!!"}
        </DialogTitle>
        <DialogContent sx={{ bgcolor: "#fff", color: "#000" }}>
          <DialogContentText id="alert-dialog-description">
            <Grid
              container
              spacing={2}
              style={{ color: "black", marginTop: "10px", paddingLeft: "20px" }}
            >
              <Grid item xs={11} md={5.5} sm={6} sx={{ marginLeft: "10px" }}>
                <Stack direction="column">
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Choose Relieve Date
                  </Typography>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    sx={{ textAlign: "center" }}
                  >
                    <DemoContainer
                      components={["DatePicker"]}
                      //  onChange={(e) => handleDateChangeRelieve(e.target.value)}
                      sx={{ marginTop: "-10px" }}
                    >
                      <DatePicker
                        value={dateRelieve}
                        onChange={handleDateChangeRelieve}
                        sx={{
                          border: "1px solid black",
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black !important",
                            color: "black !important",
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          "& .MuiSvgIcon-root": {
                            color: "black",
                          },
                        }}
                      >
                        {(params) => (
                          <TextField {...params} variant="outlined" />
                        )}
                      </DatePicker>
                    </DemoContainer>
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={1} sm={5.5} md={6} sx={{ marginLeft: "10px" }}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      color: "black",

                      padding: "4px",
                      borderRadius: "4px",
                    }}
                  >
                    Remark Type
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={remarkType}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio
                          sx={{
                            color: "black",
                            "&.Mui-checked": { color: "gray" },
                          }}
                        />
                      }
                      label="Public"
                    />
                    <FormControlLabel
                      value="2"
                      control={
                        <Radio
                          sx={{
                            color: "black",
                            "&.Mui-checked": { color: "gray" },
                          }}
                        />
                      }
                      label="Private"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={descriptionReason}
                  onChange={setDescriptionReason}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                  }}
                />
              </Stack>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ bgcolor: "#fff", color: "#000" }}>
          <Button onClick={handleCloseRelieve} variant="outline">
            Cancel
          </Button>
          <Button onClick={handleRelieve} autoFocus variant="outline">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSuspend}
        onClose={handleCloseSuspend}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            marginTop: "30px",
            top: 0,
            position: "absolute",
            height: "340px",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            bgcolor: "#1d82F5",
            color: "#fff",
            textAlign: "center",
            width: "100%",
          }}
        >
          {"Do, you want to suspend!!"}
        </DialogTitle>
        <DialogContent sx={{ bgcolor: "#fff", color: "#000" }}>
          <DialogContentText id="alert-dialog-description">
            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={descriptionSuspend}
                  onChange={setDescriptionSuspend}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                  }}
                />
              </Stack>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ bgcolor: "#fff", color: "#000" }}>
          <Button onClick={handleCloseSuspend} variant="outline">
            Cancel
          </Button>
          <Button onClick={handleSuspend} autoFocus variant="outline">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <List
        style={{
          background: "none",
          // padding: 5,
        }}
      >
        <React.Fragment>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              marginBottom: "5px",
              // marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",
                marginLeft: "10px",
                height: "40px",
                width: "120px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
                //  marginTop: "20px",
              }}
            >
              <AddIcon />
              Add Driver
            </Box>
          </Stack>
          <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                position: "absolute",
                background: "#141b2d",
                top: "0",
                backgroundColor: "white",
                maxHeight: "95%",
                margin: "auto",
                overflowX: "hidden",
                zIndex: 1200,
              },
            }}
          >
            <AppBar sx={{ position: "relative" }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography sx={{ ml: 2, flex: 1 }} component="div">
                  Add New Driver
                </Typography>
              </Toolbar>
            </AppBar>
            <Box sx={{ background: "#fff" }}>
              <Grid
                container
                spacing={2}
                style={{ color: "black", margin: "10px", paddingLeft: "20px" }}
              >
                <Grid item xs={11} sm={6} md={4.2}>
                  <Stack direction="column">
                    <Typography>Name</Typography>

                    <Autocomplete
                      freeSolo
                      options={optionsNew || []}
                      getOptionLabel={(option) => {
                        if (typeof option === "object" && option !== null) {
                          return `${option?.username || ""}`;
                        }
                        return option;
                      }}
                      filterOptions={(options, params) => {
                        const filtered = options.filter(
                          (option) =>
                            option?.phone
                              ?.toLowerCase()
                              .includes(params.inputValue.toLowerCase()) ||
                            option?.user_id
                              ?.toLowerCase()
                              .includes(params.inputValue.toLowerCase())
                        );
                        if (params.inputValue !== "" && !filtered.length) {
                          filtered.push(params.inputValue);
                        }

                        return filtered;
                      }}
                      loading={loadingNew}
                      onInputChange={(event, value) => setDriverId(value)} //
                      onChange={(event, value) => {
                        if (typeof value === "string") {
                          handleDriverChange({ user_id: value });
                        } else if (value && typeof value === "object") {
                          handleDriverChange(value);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option?.user_id === value?.user_id
                      }
                      renderOption={(props, option) => {
                        const imageUrl = `${config.apiImageUrl}${option.image}`;
                        return (
                          <li
                            {...props}
                            key={option.user_id}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            {/* Driver Image */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={imageUrl}
                                alt={option?.username}
                                style={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: "50%",
                                  marginRight: 10,
                                }}
                              />
                              {/* Driver Name and Info */}
                              <span>{option?.username || ""}</span>
                            </Box>
                            <div>{option?.user_id || ""}</div>
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search by Driver ID or Mobile Number"
                          variant="outlined"
                          fullWidth
                          sx={{
                            border: 1,
                            borderRadius: 1,
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { color: "black" },
                            endAdornment: (
                              <>
                                {loadingNew && <CircularProgress size={20} />}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={11} sm={4.2}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Client
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <TextField
                        value={username}
                        // onChange={(e) => setEmail(e.target.value)}
                        aria-readonly
                        fullWidth
                        placeholder="ramu"
                        type="email"
                        inputProps={{ style: { color: "black" } }}
                        InputLabelProps={{ style: { color: "black" } }}
                        sx={{
                          border: "1px solid black",
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black",
                            "&:hover fieldset": {
                              borderColor: "black",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black",
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            "&::placeholder": { color: "gray" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ color: "black", margin: "10px", paddingLeft: "20px" }}
              >
                <Grid item xs={11} sm={5} md={4.2}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Salary
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        placeholder="e.g.Rs 30,000"
                        inputProps={{ style: { color: "black" } }}
                        InputLabelProps={{ style: { color: "black" } }}
                        sx={{
                          border: "1px solid black",
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black",
                            "&:hover fieldset": {
                              borderColor: "black",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black",
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            "&::placeholder": { color: "gray" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4.2}
                  sm={4.2}
                  sx={{ paddingLeft: { xs: 0, sm: 2, md: 4 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        onChange={(e) => handleDateChange(e.target.value)}
                        sx={{ marginTop: "-10px" }}
                      >
                        <DatePicker
                          value={date}
                          onChange={handleDateChange}
                          sx={{
                            border: "1px solid black",
                            borderRadius: "5px",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black !important",
                              color: "black !important",
                              "&:hover fieldset": {
                                borderColor: "black !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black !important",
                              },
                            },
                            "& .MuiSvgIcon-root": {
                              color: "black",
                            },
                          }}
                        >
                          {(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        </DatePicker>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "10px 0 20px 38px" }}>
                <Grid item xs={11} className="messageFooter">
                  <Box className="response" onClick={SaveData}>
                    Save
                  </Box>
                  <Box className="cancel" onClick={handleClose}>
                    Cancel
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Dialog>
        </React.Fragment>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Driver Lists
                </span>
              }
              data={leadFiles}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default DriverClients;